export class CreateOrganizationRequest {
    name = null;
    displayName = null;
    connectionId = null;
    defaultMemberId = null;

    constructor(name, displayName, connectionId, memberId){
        this.name = name;
        this.displayName = displayName;
        this.connectionId = connectionId;
        this.defaultMemberId = memberId;
    }
}